import { render } from "./TgJsonPageEditor.vue?vue&type=template&id=fead688e"
import script from "./TgJsonPageEditor.vue?vue&type=script&lang=js"
export * from "./TgJsonPageEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__